(function () {
    'use strict';

    angular
            .module('imnApp')
            .filter('patternDate', patternDate);

    patternDate.$inject = ['$locale', '$filter'];
    function patternDate($locale, $filter) {
        return patterDateFilter;

        function patterDateFilter(input) {
            var langSelected = $locale.id;
            var pattern = null;

            if (langSelected == 'en') {
                pattern = 'MM/dd/yyyy';
            } else {
                pattern = 'dd/MM/yyyy';
            }
            var _date = $filter('date')(new Date(input), pattern);
            return _date;
        }
    }
})();


